import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, ShoppingCart, CircleDollarSign, Menu } from 'lucide-react';

/**
 * MobileBottomNav — bottom navigation bar untuk mobile (< lg breakpoint).
 * Menampilkan 4 shortcut paling sering dipakai: Dashboard, Transaksi, Cashflow, More.
 * Tombol "More" buka sidebar (delegate ke parent via onOpenSidebar).
 */
export default function MobileBottomNav({ onOpenSidebar }) {
  const location = useLocation();

  const items = [
    { id: 'dashboard', label: 'Beranda', icon: LayoutDashboard, path: '/' },
    { id: 'transactions', label: 'Transaksi', icon: ShoppingCart, path: '/transactions' },
    { id: 'cashflow', label: 'Cashflow', icon: CircleDollarSign, path: '/cashflow' },
  ];

  return (
    <nav
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white dark:bg-slate-800 border-t border-stone-200 dark:border-slate-700 shadow-[0_-2px_8px_rgba(0,0,0,0.04)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="mobile-bottom-nav"
    >
      <div className="grid grid-cols-4 gap-1 px-2 py-1.5">
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.id}
              to={item.path}
              className={`flex flex-col items-center justify-center py-1.5 rounded-lg transition-colors ${
                isActive
                  ? 'text-[#1A4D2E] bg-[#1A4D2E]/8'
                  : 'text-stone-500 active:bg-stone-100'
              }`}
              data-testid={`mobile-nav-${item.id}`}
            >
              <Icon size={20} className={isActive ? 'text-[#1A4D2E]' : ''} />
              <span className="text-[10px] font-medium mt-0.5">{item.label}</span>
            </Link>
          );
        })}
        <button
          onClick={onOpenSidebar}
          className="flex flex-col items-center justify-center py-1.5 rounded-lg text-stone-500 active:bg-stone-100"
          data-testid="mobile-nav-more"
        >
          <Menu size={20} />
          <span className="text-[10px] font-medium mt-0.5">Menu</span>
        </button>
      </div>
    </nav>
  );
}
